module.exports = __webpack_public_path__ + "img/Eigen.079eae54.png";